export default "<nb-layout windowMode>\n  <nb-layout-column >\n    <router-outlet></router-outlet>\n  </nb-layout-column>\n</nb-layout>\n"